<template>
    <div class="flex items-center justify-between mb-1 min-h-6">
        <div class="flex items-center gap-1">
            <vx-label class="mb-0!">
                <slot>
                </slot>
            </vx-label>
            <slot name="help"></slot>
        </div>

        <vx-button
            v-if="props.canReset"
            class="h-6"
            data-test="filter-label-reset"
            color="muted-light"
            size="xs"
            type="button"
            @click.prevent="emit('reset')"
        >
            Reset
        </vx-button>
    </div>
</template>

<script lang="ts" setup>
import { VxLabel, VxButton } from '@voxie/frontend-components';

const props = defineProps({
    canReset: {
        type: Boolean,
    },
});
const emit = defineEmits(['reset']);
</script>
